import { createReducer, on } from '@ngrx/store';
import {
  ActiveComponentChanged,
  ResetStateFromRouter,
} from 'src/app/shared/actions/eliqua.actions';
import {
  ChangeActiveStatus,
  ChangeInActiveStatus,
  ChangeName,
  ChangeSelectedSystem,
  ClearFilters,
  GetIntegrationTypesSuccess,
  PanelStatus,
} from '../actions/integration-management-search.actions';

export interface SearchState {
  systems: string[];
  system: string;
  name: string;
  nameValue: string;
  activeStatus: boolean;
  inActiveStatus: boolean;
  panelExpanded: boolean;
}

const initialState: SearchState = {
  systems: [],
  system: '',
  name: '',
  nameValue: '',
  activeStatus: false,
  inActiveStatus: false,
  panelExpanded: true,
};

export const SearchReducer = createReducer(
  initialState,
  on(GetIntegrationTypesSuccess, (state, { response }) => ({
    ...state,
    systems: response.payload.data,
  })),
  on(ChangeSelectedSystem, (state, { system }) => ({
    ...state,
    system: system !== undefined ? system : '',
  })),
  on(ChangeName, (state, { name }) => ({
    ...state,
    name,
  })),
  on(ChangeActiveStatus, (state, { activeStatus }) => ({
    ...state,
    activeStatus,
    nameValue: 'Name changed',
  })),
  on(ChangeInActiveStatus, (state, { inActiveStatus }) => ({
    ...state,
    inActiveStatus,
  })),
  on(ClearFilters, (state) => ({
    ...state,
    system: '',
    name: '',
    activeStatus: false,
    inActiveStatus: false,
    panelExpanded: true,
  })),
  on(PanelStatus, (state) => ({
    ...state,
    panelExpanded: !state.panelExpanded,
  })),
  on(ActiveComponentChanged, (state) => ({
    ...state,
    system: '',
    name: '',
    nameValue: '',
    activeStatus: false,
    inActiveStatus: false,
    panelExpanded: true,
  })),
  on(ResetStateFromRouter, () => ({
    ...initialState,
  })),
);
